module.exports = __webpack_public_path__ + "static/sustainacademy-8c53200182452214dac9446e5b6e23c9.png";